import { render, staticRenderFns } from "./InProgressTab.vue?vue&type=template&id=0b572626&scoped=true"
import script from "./InProgressTab.vue?vue&type=script&lang=ts"
export * from "./InProgressTab.vue?vue&type=script&lang=ts"
import style0 from "./InProgressTab.vue?vue&type=style&index=0&id=0b572626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b572626",
  null
  
)

export default component.exports